import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Layers, UserPlus, ArrowUp } from "lucide-react";
import { AddonDialog } from "@/components/AddonDialog";
import { UpgradeDialog } from "@/components/UpgradeDialog";

export function LimitReachedDialog() {
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState("account");
  const [message, setMessage] = useState("");
  const [addon, setAddon] = useState({ open: false, tab: "account" });
  const [upgrade, setUpgrade] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setKind(e.detail?.kind || "account");
      setMessage(e.detail?.message || "");
      setOpen(true);
    };
    window.addEventListener("recoveros:limit", handler);
    return () => window.removeEventListener("recoveros:limit", handler);
  }, []);

  const openAddon = (tab) => { setOpen(false); setAddon({ open: true, tab }); };
  const openUpgrade = () => { setOpen(false); setUpgrade(true); };

  const isUser = kind === "user";
  const isTrial = kind === "trial";

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md rounded-sm" data-testid="limit-reached-dialog">
          <DialogHeader>
            <div className="mx-auto h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
              <AlertTriangle size={26} className="text-amber-600" />
            </div>
            <DialogTitle className="text-center mt-2">
              {isTrial ? "Your free trial has ended" : isUser ? "You've reached your User limit" : "You've reached your Active Account limit"}
            </DialogTitle>
            <DialogDescription className="text-center">{message || "Add more capacity or upgrade your plan to continue."}</DialogDescription>
          </DialogHeader>

          <div className="space-y-2 mt-1">
            {!isUser && !isTrial && (
              <div className="grid grid-cols-3 gap-2">
                <Button variant="outline" className="rounded-sm flex-col h-auto py-2.5" onClick={() => openAddon("account")} data-testid="limit-buy-250"><Layers size={16} className="mb-1" />+250<span className="text-[10px] text-muted-foreground">₹299</span></Button>
                <Button variant="outline" className="rounded-sm flex-col h-auto py-2.5" onClick={() => openAddon("account")} data-testid="limit-buy-500"><Layers size={16} className="mb-1" />+500<span className="text-[10px] text-muted-foreground">₹499</span></Button>
                <Button variant="outline" className="rounded-sm flex-col h-auto py-2.5" onClick={() => openAddon("account")} data-testid="limit-buy-1000"><Layers size={16} className="mb-1" />+1000<span className="text-[10px] text-muted-foreground">₹799</span></Button>
              </div>
            )}
            {isUser && (
              <div className="grid grid-cols-2 gap-2">
                <Button variant="outline" className="rounded-sm gap-1.5" onClick={() => openAddon("user")} data-testid="limit-add-1-user"><UserPlus size={16} /> Add 1 User · ₹499</Button>
                <Button variant="outline" className="rounded-sm gap-1.5" onClick={() => openAddon("user")} data-testid="limit-add-5-users"><UserPlus size={16} /> Add 5 Users · ₹1,999</Button>
              </div>
            )}
            <Button className="w-full rounded-sm gap-1.5 bg-[#0B3D91] hover:bg-[#0a3578]" onClick={openUpgrade} data-testid="limit-upgrade-btn">
              <ArrowUp size={16} /> Upgrade Plan
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <AddonDialog open={addon.open} defaultTab={addon.tab}
        onOpenChange={(o) => setAddon((s) => ({ ...s, open: o }))}
        onPurchased={() => window.dispatchEvent(new Event("recoveros:usage-changed"))} />
      <UpgradeDialog open={upgrade} onOpenChange={setUpgrade} onUpgraded={() => window.dispatchEvent(new Event("recoveros:usage-changed"))} />
    </>
  );
}
